import StatGroup from './StatGroup';

// export types
export type { StatGroupProps } from './StatGroup';

// export components
export { StatGroup };
export default StatGroup;
